export const user = {
    station_code: 40,
    name: 'Dhruv Singh',
    profile_key: "url"
}